import { memo } from 'react'

import {
  ContactAdditionalInfo,
  ContactCommonInfo,
  IContact,
  TContactFormKeys,
} from 'clickNgo/entities/contact'
import { IAccessibility } from 'clickNgo/models/widget'

import styles from './CommonStep.module.scss'

interface IProps extends IAccessibility {
  contact: IContact
  formKeys: TContactFormKeys
}

export const CommonStep = memo<IProps>((props) => {
  return (
    <div className={styles.container}>
      <ContactCommonInfo {...props} isCollapsible />
      <ContactAdditionalInfo {...props} isCollapsible isCollapsed />
    </div>
  )
})

CommonStep.displayName = 'CommonStep'
